<template>
    <div>
        <Navigator />
        <section class="header9 cid-r8Lj7Mla06 mbr-fullscreen mbr-parallax-background" id="header9-l">
            <div class="container">
                <div class="media-container-column mbr-white col-md-8">
                    <h1 class="mbr-section-title align-left mbr-bold pb-3 mbr-fonts-style display-1">
                        关于Go4Pro.org
                    </h1>
                    <h3 class="mbr-section-subtitle align-left mbr-light pb-3 mbr-fonts-style display-2">
                        一个只收集编程文档的站点
                    </h3>
                    <p class="mbr-text align-left pb-3 mbr-fonts-style display-5">
                        本站点自2009年成立。BT群的几位热衷于编程的朋友决定将各自的编程心得找个地方收藏起来。于是有了这个站点。<br/>
                        本站前台及后台API由TR@SOE维护，后台机器人采集程序由猛禽维护。<br/>
                        本站所有文章都得到授权转载。各篇文章版权声明应根据各自站点声明。
                    </p>
                    <div class="mbr-section-btn align-left">
                        <a class="btn btn-md btn-primary display-4" href="/">首页</a>
                        <a class="btn btn-md btn-black-outline display-4" href="/landing">随便看看</a>
                    </div>
                </div>
            </div>
        </section>

        <Footer />
    </div>
</template>

<script>
    import Navigator from "@/components/Navigator";
    import Footer from "@/components/Footer";

    export default {
        name: "About",
        components: {
            Navigator,
            Footer,
        },
        metaInfo() {
            return {
                title: "Go4Pro.org | 关于本站点",
                htmlAttrs: {
                    lang: "zh-CN"
                },
                meta: [{
                        name: "description",
                        content: "Go4Pro.org站点说明"
                    },
                    {
                        name: "keyword",
                        content: "说明, about,go4pro.org"
                    }
                ]
            };
        },
    }
</script>